package br.com.vvrefeicoes.portal.domain.model

data class UserProfile(
    val id: String,
    val name: String,
    val permissions: Map<String, Set<PermissionAction>> = emptyMap(),
)
